<div *ngIf="market && market !== GERMAN_MARKET" class="market-badge">{{'vehicleBasicInfo.market' | translate}}: {{market}}</div>
